import React, { useState } from 'react';
import { COLORS, FONTS, cardStyle, inputStyle, labelStyle, handleInputFocus, handleInputBlur, primaryButtonStyle } from '../signup/signupStyles';

export const ContributeAndSignup = ({ question, condition, onComplete }) => {
  const [phase, setPhase] = useState('write'); // 'write' | 'thanks'
  const [answer, setAnswer] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');

  // Phase 1: Write their answer — no signup required
  if (phase === 'write') {
    return (
      <div style={{
        minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
        alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
        fontFamily: FONTS.system
      }}>
        <div style={{ ...cardStyle, maxWidth: '540px' }}>
          <div style={{
            fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
            letterSpacing: '0.8px', color: COLORS.salmon, marginBottom: '16px',
            textAlign: 'center'
          }}>
            {condition} Community
          </div>

          <h2 style={{
            fontFamily: FONTS.serif, fontSize: 'clamp(20px, 4vw, 24px)',
            fontWeight: '700', color: COLORS.text, lineHeight: 1.4,
            margin: '0 0 24px', textAlign: 'center'
          }}>
            {question.question}
          </h2>

          <textarea
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            placeholder="Share your experience..."
            rows={5}
            style={{
              width: '100%', padding: '14px 16px', fontSize: '15px',
              border: `1.5px solid ${COLORS.border}`, borderRadius: '6px',
              outline: 'none', resize: 'vertical', boxSizing: 'border-box',
              fontFamily: FONTS.system, marginBottom: '8px',
              transition: 'border-color 0.2s, box-shadow 0.2s'
            }}
          />

          {/* Inline privacy statement */}
          <p style={{
            fontSize: '12px', color: COLORS.muted, margin: '0 0 16px',
            textAlign: 'center', lineHeight: 1.5
          }}>
            Your answers are anonymous. Researchers never see your name or email.
          </p>

          <button onClick={() => setPhase('thanks')}
            disabled={!answer.trim()}
            style={{
              ...primaryButtonStyle, width: '100%', padding: '16px 24px',
              opacity: answer.trim() ? 1 : 0.4,
              cursor: answer.trim() ? 'pointer' : 'not-allowed'
            }}>
            Submit My Answer
          </button>
        </div>
      </div>
    );
  }

  // Phase 2: Thank them, optional email capture
  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 480px) {
          .vf-signup-card { padding: 32px 24px !important; }
        }
      `}</style>

      <div className="vf-signup-card" style={{ ...cardStyle, animation: 'fadeUp 0.4s ease-out' }}>
        {/* Success icon */}
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%',
          backgroundColor: `${COLORS.salmon}15`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke={COLORS.salmon} strokeWidth="2.5" strokeLinecap="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h2 style={{
          fontFamily: FONTS.serif, fontSize: '22px', fontWeight: '700',
          color: COLORS.text, margin: '0 0 8px', textAlign: 'center'
        }}>
          Thank you for sharing.
        </h2>
        <p style={{
          fontSize: '14px', color: COLORS.muted, margin: '0 0 24px',
          textAlign: 'center', lineHeight: 1.5
        }}>
          Your answer has been added to the {condition} community. Want to get notified when others respond?
        </p>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>First name (optional)</label>
          <input type="text" value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Your first name" style={inputStyle}
            onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={labelStyle}>Email (optional)</label>
          <input type="email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com" style={inputStyle}
            onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <button onClick={() => onComplete({ firstName, email, answer, condition })}
          style={{
            ...primaryButtonStyle, width: '100%', padding: '16px 24px'
          }}>
          {email ? 'Save & Notify Me' : 'Done'}
        </button>

        {!email && (
          <button onClick={() => onComplete({ firstName: '', email: '', answer, condition })}
            style={{
              width: '100%', padding: '12px 24px', marginTop: '8px',
              background: 'none', border: 'none', fontSize: '14px',
              color: COLORS.muted, cursor: 'pointer', textDecoration: 'underline'
            }}>
            Skip for now
          </button>
        )}
      </div>
    </div>
  );
};
